module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_passik_sm-27b5a8ce2f4f1f890b1a55fd481ad373.png";